export default {
  // Sở giáo dục
  SGD: 1,
  // Phòng giáo dục
  PGD: 2,
  // Trường
  School: 3,
}
